import { forwardRef, memo } from "react"

export const CenterCards = memo(forwardRef(({ getCenterCardPosition, getStackCenterCardPosition, isCenterCardsStack, centerCards }, ref) => {
    return (
        <div className="truco-center-cards" ref={ref}>
            {
                // Array.from({ length: (3 * 2) }, (_, ind) => ({ cardValue: "7O", trickCount: Math.floor(ind / 2) + 1, seatIndex: ind % 2, id: `XX-${ind}`, cardIndex: ind })).map((card, i) => {
                centerCards.map((card, i) => {
                    const { x, y, width, height, backgroundPosition: { backgroundPosition, spriteWidth, spriteHeight } } = isCenterCardsStack ? getStackCenterCardPosition(card.seatIndex, card.cardValue, card.trickCount) : getCenterCardPosition(card.seatIndex, card.cardValue)

                    return <div className="truco-card"
                        id={`truco-center-card-${i}-${card.trickCount}-${card.seatIndex}`}
                        style={{
                            display: card ? "block" : "none",
                            transform: `translate(${x}px,${y}px)`,
                            bottom: 0, left: 0,
                            backgroundSize: `${spriteWidth}px ${spriteHeight}px`,
                            "--card-width": `${width}px`, "--card-height": `${height}px`, backgroundPosition,
                        }} >
                    </div>
                }
                )
            }
        </div>
    )
}))